import { APIRoute } from '@/modules/utils'
import { IRI } from 'emt-library'

export const Route = (renewIRI: IRI): APIRoute => ({
  method: 'POST',
  path: renewIRI,
})

export type Body = never

export type Response = never
